export enum PmiStatusCodes {
  Success = 0,
  Failed = 1,
  Cancelled = 7,
  ManualEntryNotAllowed = 34,
  Declined = 20,
  InvalidCard = 51,
  CardExpired = 60,
  HostOffline = 77,
}
